import { breakpoints } from "./breakpoints";

$ = jQuery;

let isDesktop = window.innerWidth >= breakpoints.viewport_lg;

(function ($) {

    function setSidebarMaxHeight() {
        clearTimeout(window.sidebarHeightTimeout);
        window.sidebarHeightTimeout = setTimeout(() => {
            let sidebarHeight = $('.js-sidebar').find('.js-sidebarHeight').height() + 50;
            $('.js-sidebar').css('max-height', sidebarHeight + 'px');
        }, 600);
    }

    $(function () {
        if( isDesktop ) {
            setSidebarMaxHeight();
            $(window).on('resize', setSidebarMaxHeight);
        }
    });

})(jQuery);